import React from 'react';

function Experience() {

  const experienceContent = `
  I spearheaded transformative advancements in development processes by seamlessly integrating advanced technologies, catalyzing remarkable efficiency gains. Embracing an agile development methodology, I orchestrated cross-functional collaboration, resulting in the seamless delivery of high-impact software solutions. Noteworthy achievements include my pivotal role in a critical client project, where I demonstrated expertise in orchestrating intricate supply chain management and interconnected applications within a complex system architecture. Through adept utilization of cutting-edge technology skills across diverse domains, I significantly elevated team productivity, leading to substantial time and cost savings.
`;

  return (
    <div className="experience">
      <header className="sectionName">
        <div className='line' />
        <h3><i>Professional Experience</i></h3>
        <div className='line' />
      </header>
      <div className="company">
        <h3>Brillio  |  Software Development Engineer</h3>
        <h4>Nov 2022 - Present</h4>
      </div>
      <p>
        {experienceContent}
      </p>
    </div>
  );
}

export default Experience;
